import React from 'react';
import { useRangeSlider } from '../hooks/useRangeSlider';
import SearchFiltersNumeric from './generic/SearchFiltersNumeric';
import config from '../config/config';
import useRangeSliderData from '../hooks/useRangeSliderData';
import { useSearchStateFilters, useSearchStateFiltersDispatch } from '../hooks/useSearchStateFilters';

/*
    Filter for bedrooms
    Options: 2+ 3+ 4+, etc
    To cover all values, need to utilize 2 different algolia attributes min_bedrooms and max_bedrooms
        - useRangeSlider to get the min and max values for each attribute (but don't use it for the ui)
        - Get ranges of min values and max values
    Need to get ranges before useNumericMenu so need to use a another component: SearchFiltersBedrooms
    in SearchFiltersBedrooms:
        - render the options from static list (tried to render them dynamically but it was resetting values - also need to show all options)
        - create 2 numeric menus, one for min and one for max
        - toggle selected and refine depending on if the option is in the min or max range
*/
const SearchFilterBedrooms = () => {
	const dispatch = useSearchStateFiltersDispatch();
	const { bedrooms } = useSearchStateFilters();
	// these change, initially the min and max is 0, but that causes issues
	// when that is dynamic in numeric menu
	const minRangeSlider = useRangeSlider( { attribute: config.FILTER_ATTRIBUTES.bedMin, step: 1 } );
	const maxRangeSlider = useRangeSlider( { attribute: config.FILTER_ATTRIBUTES.bedMax, step: 1 } );
	const { isReady, ranges } = useRangeSliderData( { minRangeSlider, maxRangeSlider } );

	const onChange = ( { min = null, max = null } ) => {
		dispatch( {
			type: 'changed',
			bedrooms: { min, max },
		} );
	};

	if ( ! isReady ) {
		return null;
	}
	// console.log( 'bed', minRangeSlider, maxRangeSlider, ranges );

	return (
		<div>
			<SearchFiltersNumeric
				ranges={ranges}
				id="bedrooms"
				options={config.FILTER_OPTIONS_BEDROOM}
				onChange={onChange}
				label="Bedrooms"
				activeMin={bedrooms.min}
				activeMax={bedrooms.max}
			/>
		</div>
	);
};

export default SearchFilterBedrooms;

